module.exports = __webpack_public_path__ + "img/damage-home.e37298ec.jpg";